export default "__VITE_ASSET__oHvOF3py__"